<template>
  <div class="container-fluid pt-0 mt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <!-- <div class="row">
      <div class="col-5">
        <h4 class="p-b-20">{{ $t("overview") }}</h4>
      </div>
    </div> -->
    <div class="row">
      <div class="col-lg-3 col-md-3">
        <IconCard
          :label="$t('avg_temp')"
          :title="`${cardTitleTemp} °C`"
          :iconColor="'background-color: rgba(158, 198, 221, 0.30);'"
        >
          <template slot="icon">
            <IconTemp />
          </template>
        </IconCard>
      </div>
      <div class="col-lg-3 col-md-3">
        <IconCard
          :label="$t('avg_humid')"
          :title="`${cardTitleHumi} %`"
          iconColor="background-color: rgba(143, 205, 159, 0.30)"
        >
          <template slot="icon">
            <IconHumi />
          </template>
        </IconCard>
      </div>
      <div class="col-lg-3 col-md-3">
        <IconCard
          :label="$t('devices')"
          :title="`${singlegroupoverview.devices.all}`"
          iconColor="background-color: rgba(243, 201, 99, 0.30);"
          bgColor="color: #565f6b"
          :to="'/groups/' + this.$route.params.id + '/devices'"
        >
          <template slot="icon">
            <IconDevices />
          </template>
        </IconCard>
      </div>
      <div class="col-lg-3 col-md-3">
        <IconCard
          :label="`${$t('critical')} ${$t('devices')}`"
          :title="`${singlegroupoverview.devices.criticals}`"
          iconColor="background-color: rgba(244, 169, 169, 0.30)"
        >
          <template slot="icon">
            <IconCritical />
          </template>
        </IconCard>
      </div>
    </div>

    <div class="row m-b-20">
      <div class="col-lg-9 col-md-8 col-sm-7">
        <div class="card" style="height: 100%;">
          <div v-if="singlegroupstats.group" class="card-body">
            <div
              class="p-20"
              v-if="singlegroupstats.stats.length == 0"
              align="center"
            >
              <h4 class="text-muted">
                {{ $t("no_temp") }}
              </h4>
            </div>

            <div style="" v-else>
              <div
                class="d-flex justify-content-space-around col-md-8 col-lg-6 mx-auto"
              >
                <div class="btn-container">
                  <button
                    @click="
                      tempGraph = true;
                      humiGraph = false;
                    "
                    :disabled="tempGraph == true"
                    id="graphselect"
                  >
                    {{ $t("temp") }}
                  </button>
                </div>
                <div class="btn-container">
                  <button
                    @click="
                      tempGraph = false;
                      humiGraph = true;
                    "
                    :disabled="tempGraph == false"
                    id="graphselect"
                  >
                    {{ $t("humid") }}
                  </button>
                </div>
              </div>
              <div>
                <GeneralGroupChart
                  :tempGraph="tempGraph"
                  :humiGraph="humiGraph"
                  :singlegroup="singlegroupstats"
                  :title="title"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-5">
        <div class="card" style="height: 100%; min-height: 500px">
          <div class="card-body">
            <div
              class="d-flex align-items-center justify-content-between mb-4 mt-1"
            >
              <span class="font-weight-bold font-16">Users</span>
              <router-link
                :to="'/groups/' + this.$route.params.id + '/users'"
                class="view-more"
              >
                View more
                <ArrowForward />
              </router-link>
            </div>
            <div class="block logs">
              <div
                v-for="user in singlegroupId.users.slice(0, 10)"
                :key="user.id"
                class="d-flex col-gap-1 mb-3"
              >
                <div class="audit-icon">
                  <IconUser />
                </div>
                <div class="">
                  <p class="mb-0" style="max-width: 23rem;">
                    {{ user.fullname }}
                  </p>
                  <p
                    class="mb-0 font-12"
                    style="max-width: 23rem;color:rgba(28, 28, 28, 0.40)"
                  >
                    {{ user.email }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
// import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
// import GeneralGroupChart from "../../components/Groups/GeneralGroupChart"
import IconCard from "../../components/IconCard";
import IconTemp from "../../components/Iconsvg/IconTempBig.vue";
import IconHumi from "../../components/Iconsvg/IconHumiBig.vue";
import IconCritical from "../../components/Iconsvg/IconCritical";
import IconDevices from "../../components/Iconsvg/IconDevices";
import IconUser from "../../components/Iconsvg/IconDevices";
import ArrowForward from "../../components/Iconsvg/ArrowForward";

export default {
  name: "GroupOverview",
  data() {
    return {
      isLoading: false,
      fullPage: true,

      tempGraph: true,
      humiGraph: false,
      singlegroup: {},
    };
  },
  props: {
    title: String,
  },
  computed: {
    ...mapGetters([
      "singlegroupoverview",
      "singlegroupstats",
      "singlegroupId",
      "singlegroupdevices",
      "singlegroupstats",
    ]),
    cardTitleTemp() {
      let temp = this.singlegroupoverview?.averageStats?.temperature;
      return temp ? temp.toFixed(2) : "-";
    },
    cardTitleHumi() {
      let humi = this.singlegroupoverview?.averageStats?.humidity;
      return humi ? humi.toFixed(2) : "-";
    },
  },
  components: {
    Loading,
    // GeneralGroupChart,
    GeneralGroupChart: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Groups/GeneralGroupChart"
      ),
    IconCard,
    IconTemp,
    IconHumi,
    IconDevices,
    IconCritical,
    IconUser,
    ArrowForward,
  },
  methods: {
    ...mapActions(["fetchSingleGroupOverview", "fetchSingleGroupStats"]),
  },
  mounted() {
    this.isLoading = true;
    this.fetchSingleGroupOverview({ id: this.$route.params.id });
    this.fetchSingleGroupStats({ id: this.$route.params.id })
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
  watch: {
    // singlegroupoverview: {
    //   handler: function() {
    //     const val = {
    //       ...this.singlegroupoverview?.overview,
    //       stats: this.singlegroupstats.stats,
    //     };
    //     this.singlegroup = {
    //       overview: val,
    //       group: this.singlegroupId.group,
    //       criticals: this.singlegroupdevices.criticals,
    //       devices: this.singlegroupdevices.devicesLength,
    //     };
    //   },
    //   deep: true,
    // },
  },
};
</script>

<style scoped>
.btn-container {
  display: flex;
  justify-content: center;
  width: 50%;
}
.audit-icon {
  width: 35px;
  /* border: solid; */
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #dee2eb;
}
.view-more {
  color: #213e7a !important;
}

#graphselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled] {
  background-color: #dee2eb;
  color: #213e7a;
}
</style>
<i18n>
{
	"en": {
		"nil": "Nil",
		"no_temp": "No Temperature/Humidity data available for the devices in this group for today",
		"overview": "Overview"
	},
	"es": {
		"nil": "Nulo",
		"no_temp": "No hay datos de temperatura/humedad disponibles para los dispositivos de este grupo para hoy",
		"overview": "Visión general"
	},
	"fr": {
		"nil": "Néant",
		"no_temp": "Aucune donnée de température/humidité disponible pour les appareils de ce groupe pour aujourd'hui",
		"overview": "Aperçu"
	},
	"sw": {
		"nil": "Nil",
		"no_temp": "Hakuna data ya Halijoto/Unyevu inayopatikana kwa vifaa vilivyo katika kikundi hiki kwa leo",
		"overview": "Maelezo ya jumla"
	}
}
</i18n>
